import React, { Component } from 'react'

import {
    AudioRecorders,
    Cameras,
    ComputersSimple,
    Lenses,
    LightingKits,
    Microphones,
    Monitors,
    ProductionEquipment,
    SupportEquipment,
    VideoRecorders,
    WirelessSystems,
} from './'

class VideoWrapper extends Component {
    render() {
        return (
            <div>
                <Cameras { ...this.props } type="video" />
                <Lenses { ...this.props } />
                <SupportEquipment { ...this.props } />
                <Microphones { ...this.props } />
                <AudioRecorders { ...this.props } />
                <VideoRecorders { ...this.props } />
                <WirelessSystems { ...this.props } type="video" />
                <LightingKits { ...this.props } type="video" />
                <ComputersSimple { ...this.props } />
                <Monitors { ...this.props } />
                <ProductionEquipment { ...this.props } />
            </div>
        )
    }
}

VideoWrapper.propTypes = {
    appState: React.PropTypes.object,
    crew_uuid: React.PropTypes.string,
    gear: React.PropTypes.object,
    gearActions: React.PropTypes.object,
    personalActions: React.PropTypes.object,
}

export default VideoWrapper



// WEBPACK FOOTER //
// ./app/components/gear/video_wrapper.js